'use client'

import React, { useMemo } from 'react'
import { useRouter } from 'next/navigation'
import { useFocus } from '@/providers/focus-provider'
import { Button } from '@/components/ui/button'
import { Clock } from 'lucide-react'

export default function FocusStatusBadge() {
  const router = useRouter()
  const { running, timeLeftSec, elapsedSec, stopCycle } = useFocus()

  const timeText = useMemo(() => formatTime(running ? timeLeftSec : 0), [running, timeLeftSec])
  const title = running ? `Fokus aktiv – Rest: ${timeText}` : 'Kein Fokuslauf'

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        mode="icon"
        shape="circle"
        className={`size-9 hover:bg-primary/10 hover:[&_svg]:text-primary ${running ? 'ring-2 ring-red-300' : ''}`}
        title={title}
        onClick={() => router.push('/tickets')}
      >
        <div className="relative">
          <Clock className={`size-4.5! ${running ? 'text-red-500' : ''}`} />
          {running && (
            <span className="absolute -top-0.5 -right-0.5 block w-2 h-2 bg-red-500 rounded-full animate-pulse" />
          )}
        </div>
      </Button>
      <div className="hidden xl:flex items-center gap-2 text-xs text-muted-foreground">
        {running ? (
          <>
            <span className="font-semibold text-foreground">{timeText}</span>
            <button
              className="px-2 py-0.5 rounded border text-foreground/80 hover:bg-muted/40"
              onClick={stopCycle}
              title="Fokuslauf stoppen"
            >
              Stop
            </button>
          </>
        ) : (
          <span>Fokus aus</span>
        )}
      </div>
    </div>
  )
}

function formatTime(seconds) {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}

